import { Tooltip } from "@mui/material";
import NumberFormat from "react-number-format";

export const OneLead = ({ item }) => {
  /* console.log({ item }); */
  return (
    <div
      key={item.id}
      className={`text-start p-3 relative rounded mt-[5px] border-s-2 ${item?.estado === "archivado" ? "border-orange-500" : "border-green-500"}`}
    >
      {item.estado_comercial && item.estado_comercial !== 'abierta' && <span className={`inline-block text-xs mb-2 px-2 py-1 rounded ${item.estado_comercial === 'ganada' ? 'bg-green-50 text-green-700' : 'bg-red-50 text-red-700'}`}>{item.estado_comercial === 'ganada' ? 'Ganada' : 'Perdida'}</span>}
      <div className="text-[16px] text-[#595759] capitalize">
        {item.contacto}
      </div>
      <div className="text-[14px] text-[#909090] mt-1">{item.referencia}</div>

      {item?.total ? (
        <div className="d-flex justify-content-between mt-2 text-[#5CBF66] text-[14px]">
          <NumberFormat
            className="text-end"
            displayType={"text"}
            value={item?.total || 0}
            thousandSeparator={item?.separacion_miles || ","}
            decimalSeparator={item?.separacion_decimales || "."}
            prefix={`${item.simbolo} `}
            decimalScale={2}
            fixedDecimalScale={2}
          />
        </div>
      ) : (
        ""
      )}

      <div className="flex justify-between mt-3">
        {item?.nota ? (
          <div>
            <Tooltip title={`nota: ${item?.nota}`}>
              <i
                className="bi bi-card-text text-[14px] text-[--primary-color]"
                style={{ cursor: "pointer" }}
              ></i>
            </Tooltip>
          </div>
        ) : (
          <div className="text-transparent">--</div>
        )}

        <div>
          {item?.status_actividad === "sin_actividad" && (
            <Tooltip title="Sin actividad programada">
              <i className="bi bi-exclamation-triangle text-[16px] absolute text-yellow-500 font-extrabold right-5"></i>
            </Tooltip>
          )}

          {item?.status_actividad === "actividad_programada" && (
            <Tooltip title="Tiene actividad programada">
              <i className="bi bi-check2-square text-[16px] absolute text-gray-500 font-extrabold right-5"></i>
            </Tooltip>
          )}

          {item?.status_actividad === "actividad_hoy" && (
            <Tooltip title="Tiene actividad programada para hoy">
              <i className="bi bi-check2-square text-[16px] absolute text-green-500 font-extrabold right-5"></i>
            </Tooltip>
          )}

          {item?.status_actividad === "actividad_vencida" && (
            <Tooltip title="Tiene actividad vencida">
              <i className="bi bi-check2-square text-[16px] absolute text-red-500 font-extrabold right-5"></i>
            </Tooltip>
          )}
        </div>
      </div>
    </div>
  );
};
